/** 提交前校验失败（由 validateSubmit / assertSubmitReady 抛出，serialize 不再 throw） */
export class SubmitValidationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'SubmitValidationError';
  }
}

export function resolveSubmitOverlayText(...candidates: unknown[]): string {
  for (const candidate of candidates) {
    const text = String(candidate ?? '').trim();
    if (text) return text;
  }
  return '';
}
